export class ModifyDesignRequest
{
    constructor(
            public readonly name:string, 
            public readonly description:string
        )
    {}
}
